import React, { useState, useEffect, useMemo } from "react";
import Sidebar from "../../components/layout/Sidebar";
import ApplicationList from "../../components/applications/ApplicationList/ApplicationList";
import { useAuth } from "../../context/AuthContext";
import CardHeader from "../../components/common/CardHeader";

function ApplicationsShipping() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const { checkPermission } = useAuth();

  const appMode = useMemo(
    () =>
      checkPermission("Zmiana przypisania sprawy")
        ? "coordinator"
        : checkPermission("Obsługa wniosków")
        ? "operator"
        : checkPermission("Obsługa wysyłki")
        ? "shipping"
        : "user",
    [checkPermission]
  );

  const finalShippingMode = useMemo(
    () => checkPermission("Obsługa wysyłki"),
    [checkPermission]
  );

  const handleResize = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarVisible(true);
    } else {
      setIsSidebarVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <CardHeader text={"Wysyłka wniosków "} onlyText="true" />
      <ApplicationList
        mode={appMode}
        paymentMode={false}
        shippingMode={finalShippingMode}
      />
    </>
  );
}

export default ApplicationsShipping;
